import Card from "components/Card/Card";
// import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import moment from "moment";
// import moment from "react-big-calendar/lib/localizers/moment";
import {
  Button,
  Col,
  Row,
  Table,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  Pagination,
} from "react-bootstrap";
import LoadingSpinner from "views/Components/loadingSpinner";

import Datetime from "react-datetime";
import NotificationSystem from "react-notification-system";
import Swal from "sweetalert2";
import DateRangePicker from "react-daterange-picker";
import { GetAllExpiryMedicineData } from "Listfunction";

const ExpiryMedicineList = (props) => {
  const _notificationSystem = React.createRef();
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;

  const [loading, setloading] = useState(false);
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [expiryMEdicationData, setExpiryMEdicationData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();


  useEffect(() => {
    setloading(true);
    // getAllPoDetails()
    GetAllExpiryMedicineData(obj, currentPage).then((res) => {
      setExpiryMEdicationData(res.data.data);
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
  }, []);

  let active = currentPage;
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        onClick={() => GetAllExpiryMedicineData(obj, number)}
        active={number === active}
      >
        {number}
      </Pagination.Item>
    );
  }
  
  return (
    <>
      <Col xs={12} sm={12} md={12} lg={12}>
        <NotificationSystem ref={_notificationSystem} />
      </Col>
      <Col md={12}>
        <Card
          content={
            <React.Fragment>
              <Row>
                <Col md={12}>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Medicine ID</th>
                        <th>Item Code</th>
                        <th>Expiry Quantity</th>
                        <th>Expiry Date</th>
                        {/* <th>User ID</th> */}
                        <th>Created Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colspan="10">
                            <LoadingSpinner />
                          </td>
                        </tr>
                      ) : noRecordFound ? (
                        <tr>
                          <td colspan="10">
                            <center>No record found</center>
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {expiryMEdicationData && expiryMEdicationData.map((data)=> (

                            <tr>
                            <td>{data.medication_id !== null || data.medication_id !== "" ? data.medication_id : "-"}</td>
                            <td>{data.item_code !== null || data.item_code !== "" ? data.item_code : "-"}</td>
                            <td style={{alignItems: "center"}}>{data.quantity !== null || data.quantity !== "" ? data.quantity : "-"}</td>
                            <td>{data.expiry_date !== null || data.expiry_date !== "" ? data.expiry_date : "-"}</td>
                            {/* <td>{data.logged_user_id !== null || data.logged_user_id !== "" ? data.logged_user_id : "-"}</td> */}
                            <td>{data.created_at !== null || data.created_at !== "" ? data.created_at : "-"}</td>
                          </tr>
                            ))}
                          
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </React.Fragment>
          }
        />
         <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Pagination bsSize="medium">{items}</Pagination>
        </div>
      </Col>
    </>
  );
};

export default ExpiryMedicineList;
